var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1016 24.625C19.1682 24.625 17.5182 23.9417 16.1516 22.575C14.7849 21.2083 14.1016 19.5583 14.1016 17.625V11.625C14.1016 9.69167 14.7849 8.04167 16.1516 6.675C17.5182 5.30833 19.1682 4.625 21.1016 4.625C23.0349 4.625 24.6849 5.30833 26.0516 6.675C27.4182 8.04167 28.1016 9.69167 28.1016 11.625V17.625C28.1016 19.5583 27.4182 21.2083 26.0516 22.575C24.6849 23.9417 23.0349 24.625 21.1016 24.625ZM16.1016 11.625H20.1016V6.725C18.9516 6.95833 17.9974 7.53333 17.2391 8.45C16.4807 9.36667 16.1016 10.425 16.1016 11.625ZM21.1016 22.625C22.4849 22.625 23.6641 22.1375 24.6391 21.1625C25.6141 20.1875 26.1016 19.0083 26.1016 17.625V13.625H16.1016V17.625C16.1016 19.0083 16.5891 20.1875 17.5641 21.1625C18.5391 22.1375 19.7182 22.625 21.1016 22.625Z",
    fill: "#0D0A0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8984 1.375H1.89844V18.375H11.8984",
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseAreaIcon);
export default __webpack_public_path__ + "static/media/MouseAreaIcon.20d82a8dc00bf3516f878d996d67f41d.svg";
export { ForwardRef as ReactComponent };